import { addNavMenuItem } from "@bb-vendure/admin-ui/core";

export default [
  addNavMenuItem(
    {
      id: "remote-config",
      label: "remote-config.remote-config",
      routerLink: ["/remote-config"],
      icon: "link",
    },
    "system"
  ),
];
